module.exports = __webpack_public_path__ + "img/top_2.36cdc1da.jpg";